// 用户权限变量
const produceOrderGet = [
  'produceOrderGet',
  'produceOrderGetByFollower',
  'produceOrderGetByPmc',
  'produceOrderGetByManager',
  'produceOrderGetByPurchaseUser',
  'produceOrderGetByPatternDesignerName',
]; // 生产单-查看（查看 | 查看（按跟单员判断）|  查看（按PMC判断）| 查看（按生产负责人判断）| 查看（按采购员判断））| 查看（按设计师判断）| 查看（按纸样师判断）
const goodsGet = [
  'goodsGet',
  'goodsGetByFollower',
  'goodsGetByBrand',
  'goodsGetByDesignAssistant',
]; // 商品-查看（查看（按设计师判断） || 查看（按跟单员判断）  查看（按品牌判断） 查看（按设计助理判断））
const designGet = [
  'designGet',
  'designGetByFollower',
  'designGetByBrand',
  'designGetByDesignAssistant',
]; // 设计款（旗舰版）-查看（查看（按设计师判断） | 查看（按跟单员判断） | 查看（按品牌判断） | 查看（按设计助理判断））
const rolePermission: Record<string, string[] | string[][]> = {
  // 成品盘点-草稿-盘点
  goodsStoreOrderEdit: ['goodsStoreOrderDraft', 'goodsStoreOrderSubmit'],
  // 样衣盘点-草稿-盘点
  designStoreOrderEdit: ['designStoreOrderDraft', 'designStoreOrderSubmit'],
  // 成品调拨-草稿-调拨
  goodsStoreTransferOrderEdit: [
    'goodsStoreTransferOrderDraft',
    'goodsStoreTransferOrderSubmit',
  ],
  // 出库退货-草稿-保存
  goodsRejectOrderEdit: ['goodsRejectOrderDraft', 'goodsRejectOrderSubmit'],
  produceOrderGet, // 生产单-查看（查看 | 查看（按跟单员判断））
  produceOrderDt: produceOrderGet.map((p) => {
    return [p, 'produceOrderListGet'];
  }), // 生产单详情，必须要有生产单详情的权限(produceOrderListGet)
  goodsGet, // 商品-查看（查看（按设计师判断） || 查看（按跟单员判断）  查看（按品牌判断））
  designGet, // 设计款（旗舰版）-查看（查看（按设计师判断） | 查看（按跟单员判断） | 查看（按品牌判断））
  // 生产单-草稿-保存
  produceOrderEdit: ['produceOrderDraft', 'produceOrderSubmit'],
  producePlanOrderEdit: ['producePlanOrderDraft', 'producePlanOrderAdd'],
  // 生产单-修改物料BOM
  produceMaterialBOMEdit: ['goodsEdit', 'produceOrderSubmit'],
  // 生产单-打印
  produceOrderPrint: ['produceOrderPrint', ...produceOrderGet, ...goodsGet],
  repairOrderEdit: ['repairDraft', 'repairAdd'],
  // 商品编辑
  goodsEdit: ['goodsEdit'],
  // 设计款编辑
  designEdit: ['designEdit'],
  // 物料编辑
  materialEdit: ['materialEdit'],
  // 采购单-草稿-保存
  materialPurchaseOrderEdit: [
    'materialPurchaseOrderDraft',
    'materialPurchaseOrderSubmit',
  ],
  // 采购退货单-草稿-保存
  materialPurchaseRefundOrderEdit: [
    'materialPurchaseRefundOrderDraft',
    'materialPurchaseRefundOrderSubmit',
  ],
  // 物料盘点-草稿-盘点
  materialStoreOrderEdit: [
    'materialStoreOrderDraft',
    'materialStoreOrderSubmit',
  ],
  // 物料调拨-草稿-调拨
  materialStoreTransferOrderEdit: [
    'materialStoreTransferOrderSubmit',
    'materialStoreTransferOrderDraft',
  ],
  // 物料库存流水
  materialStoredRecordGet: ['materialStoredRecordGet'],
  // 生产出库-草稿-出库
  produceStoreOutOrderEdit: [
    'produceStoreOutOrderDraft',
    'produceStoreOutOrderSubmit',
  ],
  // 生产入库-草稿-入库
  produceStoreInOrderEdit: [
    'produceStoreInOrderDraft',
    'produceStoreInOrderSubmit',
  ],
  // 物料领料-草稿-领料
  materialPickOrderEdit: ['materialPickOrderDraft', 'materialPickOrderSubmit'],
  // 物料退料-草稿-退料
  materialRefundOrderEdit: [
    'materialRefundOrderDraft',
    'materialRefundOrderSubmit',
  ],
  // 出库退货-草稿-退货
  shipmentReturnOrderEdit: ['goodsRejectOrderDraft', 'goodsRejectOrderSubmit'],
  // 次品返厂-草稿-返厂
  reworkOrderEdit: ['reworkOrderSaveDraft', 'reworkOrderSubmit'],
  // 质检—草稿-保存
  inspectionOrderEdit: ['inspectionAdd', 'inspectionDraft'],
  // 费用报销-草稿-保存
  feeReimbursementOrderEdit: ['feeReimbursementSave', 'feeReimbursementSubmit'],
  // 费用报销-草稿-查看
  feeReimbursementOrderGet: [
    'feeReimbursementGetByPayee',
    'feeReimbursementGetByCreate',
  ],
  // 费用预支-草稿-保存
  feeAdvanceOrderEdit: ['feeAdvanceSave', 'feeAdvanceSubmit'],
  // 费用预支-草稿-查看
  feeAdvanceOrderGet: ['feeAdvanceGetByApplicant', 'feeAdvanceGetByCreate'],
  // 工序外发-新增
  outwardOrderEdit: ['outwardOrderSubmit', 'supplierInfoGetDataPermission'],
};
export default rolePermission;
